import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from './components/navigation/ProtectedRoute';
import UnitsManagementSystem from './pages/units-management-system';
import AdminAuthenticationPortal from './pages/admin-authentication-portal';
import AuthenticationCallbackHandler from './pages/authentication-callback-handler';

import DriversManagementPortal from './pages/drivers-management-portal';
import YardsManagementInterface from './pages/yards-management-interface';
import AssignmentManagementCenter from './pages/assignment-management-center';
import DriverLookupPortal from './pages/driver-lookup-portal';
import ServiceRequestForm from './pages/service-request-form';
import ServiceRequestConfirmation from './pages/service-request-confirmation';
import ServiceRequestHistory from './pages/service-request-history';
import ServiceRequestManagementDashboard from './pages/service-request-management-dashboard';
import TechnicianPortalDashboard from './pages/technician-portal-dashboard';
import ServiceRequestDetailUpdates from './pages/service-request-detail-updates';
import PartsInventoryTracker from './pages/parts-inventory-tracker';
import FleetContactsManagement from './pages/fleet-contacts-management';
import NotificationRecipients from './pages/notification-recipients';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<DriverLookupPortal />} />
        <Route path="/driver-lookup-portal" element={<DriverLookupPortal />} />
        <Route path="/service-request-form" element={<ServiceRequestForm />} />
        <Route path="/service-request-confirmation" element={<ServiceRequestConfirmation />} />
        <Route path="/service-request-history" element={<ServiceRequestHistory />} />
        <Route path="/admin-authentication-portal" element={<AdminAuthenticationPortal />} />
        <Route path="/admin-login" element={<AdminAuthenticationPortal />} />
        <Route path="/admin" element={<AdminAuthenticationPortal />} />
        <Route path="/auth/callback" element={<AuthenticationCallbackHandler />} />
        
        {/* Protected admin routes */}
        {/* Default admin landing: redirect /fleet-operations-dashboard to service requests */}
        <Route path="/fleet-operations-dashboard" element={<ProtectedRoute><Navigate to="/service-request-management-dashboard" replace /></ProtectedRoute>} />
        <Route path="/units-management-system" element={<ProtectedRoute><UnitsManagementSystem /></ProtectedRoute>} />
        <Route path="/drivers-management-portal" element={<ProtectedRoute><DriversManagementPortal /></ProtectedRoute>} />
        <Route path="/yards-management-interface" element={<ProtectedRoute><YardsManagementInterface /></ProtectedRoute>} />
        <Route path="/assignment-management-center" element={<ProtectedRoute><AssignmentManagementCenter /></ProtectedRoute>} />
        <Route path="/service-request-management-dashboard" element={<ProtectedRoute><ServiceRequestManagementDashboard /></ProtectedRoute>} />
        <Route path="/technician-portal-dashboard" element={<ProtectedRoute><TechnicianPortalDashboard /></ProtectedRoute>} />
        <Route path="/service-request-detail-updates" element={<ProtectedRoute><ServiceRequestDetailUpdates /></ProtectedRoute>} />
        <Route path="/parts-inventory-tracker" element={<ProtectedRoute><PartsInventoryTracker /></ProtectedRoute>} />
        <Route path="/fleet-contacts-management" element={<ProtectedRoute><FleetContactsManagement /></ProtectedRoute>} />
        <Route path="/notification-recipients" element={<ProtectedRoute><NotificationRecipients /></ProtectedRoute>} />
        <Route path="/rpm-personnel" element={<ProtectedRoute><NotificationRecipients /></ProtectedRoute>} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;